import PropTypes from 'prop-types';
import React from 'react';

import classNames from 'classnames';

import CopyToClipboardButton from 'components/buttons/CopyToClipboardButton';

const AgencySectionPlaceholder = ({
  title = '',
  description = '',
  paddingClassName = 'p-8',
  className = '',
  testId = '',
  copyText = '',
}) => (
  <li
    className={classNames(
      'border border-dashed rounded-lg border-gray-200 bg-white flex flex-col justify-center items-center text-center space-y-2',
      paddingClassName,
      className
    )}
  >
    <p className="text-gray-300 text-xl font-medium">{title}</p>
    <p className="text-gray-300 text-sm font-normal">{description}</p>

    <CopyToClipboardButton
      copyText={copyText}
      moduleName="Invite link"
      testId={testId}
    />
  </li>
);

AgencySectionPlaceholder.propTypes = {
  title: PropTypes.string.isRequired,
  copyText: PropTypes.string,
  description: PropTypes.string,
  paddingClassName: PropTypes.string,
  className: PropTypes.string,
  testId: PropTypes.string,
};

export default AgencySectionPlaceholder;
